"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whichAnimationEvent = void 0;
const whichAnimationEvent = () => {
    const el = document.createElement('fakeelement');
    const transitions = {
        animation: 'animationend',
        OAnimation: 'oAnimationEnd',
        MozAnimation: 'animationend',
        WebkitAnimation: 'webkitAnimationEnd',
    };
    let transition = null;
    Object.keys(transitions).forEach((t) => {
        if (typeof el.style[t] !== 'undefined') {
            transition = transitions[t];
        }
    });
    return transition;
};
exports.whichAnimationEvent = whichAnimationEvent;
//# sourceMappingURL=utils.js.map